export interface Tariff {
    tariffId: number;
    tariffCode: string;
    dutiable: string;
    shortDescriptionIn?: string;
    uom: string;
    validFrom: Date;
    validTo: Date;
}

export interface TariffRate {
    tariffRatesId: number;
    tariffCode: string;
    rateTypeForImport: string;
    rateAdValerom?:any;
    rateSpecificForImport?:any;
    rateSpecificCriteriaForImport?:any;
    rateSpecificQualifierForImport?:any;
    rateTypeForExport: string;
    version: number;
    rateAdValeromExport: number;
    rateSpecificExport?:any;
    rateSpecificCriteriaExport?:any;
    validFrom: string;
    validTo: string;
    antiDumpingFree: number;
    tariffMasterDto?:any;
}

export interface Content {
    tariffId: number;
    tariffCode: string;
    chapterCode: string;
    headingCode: string;
    subHeadingCode1: string;
    subHeadingCode2: string;
    type: string;
    lenth?:any;
    descriptionInEnglish: string;
    descriptionInSecondLanguage: string;
    shortDescriptionInEnglish: string;
    shortDescriptionInSecondLanguage: string;
    validFrom: string;
    validTo: string;
    active: string;
    dutiable: string;
    uom: string;
    minDuty: number;
    maxDuty: number;
    version?:any;
    createdBy?:any;
    creationDateAndTime: Date;
    modifiedBy?:any;
    modifiedDateTime?:any;
    tariffCreatedMethod?:any;
    tariffUpdateMethod?:any;
    referenceTariffUpload?:any;
    tariffRates: TariffRate[];
    tariffControl?:any;
}

export interface TariffView {
    statusCode: number;
    message: string;
    errorMessages: [];
    content: Content;
}
